import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
const addUser = (name,title,language,timezone,email,work_phone,phone,user) => {
  return axios.post(API + "company/create-employee/", {
    name,
    title,
    language,
    timezone,
    email,
    work_phone,
    phone,
    user
  },{headers: authHeader(),});
};
const AddUserService = {
    addUser,
  };
  export default AddUserService;